import { takeLatest, put, call } from 'redux-saga/effects';

import { LOADER_CLOSE, LOADER_OPEN } from '../actions';

import notification from '../../api/notification';
import {
  NOTIFICATION_DELETE,
  NOTIFICATION_DETAILS_GET,
  NOTIFICATION_GET,
  NOTIFICATION_READ,
  SITE_NOTIFICATION_TOGGLE,
} from '../actions/notifications';
import { USER_INFO_GET } from '../actions/user';

function* getNotification({ filters, saveIn = 'both', updateHeader }) {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { data: response = {} },
    } = yield call(notification.getNotification, {
      ...filters,
      sort_by: filters?.sort_by ?? 'not_read',
    });
    yield put({ type: NOTIFICATION_GET._SUCCESS, response, saveIn });
    if (updateHeader) {
      yield put({ type: NOTIFICATION_GET._REQUEST, saveIn: 'header' });
    }
  } catch (error) {
    yield put({ type: NOTIFICATION_GET._ERROR, error });
    // eslint-disable-next-line no-console
    console.log('sagas > notification > getNotification', error);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* NotificationGetWatch() {
  yield takeLatest(NOTIFICATION_GET._REQUEST, getNotification);
}

function* notificationRead({ ids, status, filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const params = {
      notifications_ids: ids,
      notification_status: status,
    };
    yield call(notification.notificationRead, params);
    yield put({ type: NOTIFICATION_READ._SUCCESS });
    yield put({ type: NOTIFICATION_GET._REQUEST, filters, updateHeader: true });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > notification > notificationRead', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* notificationReadWatch() {
  yield takeLatest(NOTIFICATION_READ._REQUEST, notificationRead);
}

function* notificationDelete({ ids, filters = {} }) {
  try {
    yield put({ type: LOADER_OPEN });
    const params = {
      notifications_ids: ids,
    };
    yield call(notification.notificationDelete, params);
    yield put({ type: NOTIFICATION_DELETE._SUCCESS });
    yield put({ type: NOTIFICATION_GET._REQUEST, filters, updateHeader: true });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > notification > notificationDelete', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* notificationDeleteWatch() {
  yield takeLatest(NOTIFICATION_DELETE._REQUEST, notificationDelete);
}

function* notificationDetailsGet({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { data },
    } = yield call(notification.notificationDetailsGet, id);
    yield put({ type: NOTIFICATION_DETAILS_GET._SUCCESS, data });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > notification > notificationDetailsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* notificationDetailsGetWatch() {
  yield takeLatest(NOTIFICATION_DETAILS_GET._REQUEST, notificationDetailsGet);
}

function* siteNotification({ body }) {
  try {
    yield put({ type: LOADER_OPEN });
    const {
      data: { data },
    } = yield call(notification.siteNotification, body);
    if (data?.updated) {
      yield put({ type: SITE_NOTIFICATION_TOGGLE._SUCCESS });
      yield put({ type: USER_INFO_GET._REQUEST });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > notification > siteNotification', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* siteNotificationWatch() {
  yield takeLatest(SITE_NOTIFICATION_TOGGLE._REQUEST, siteNotification);
}

export default [
  NotificationGetWatch(),
  notificationReadWatch(),
  notificationDeleteWatch(),
  notificationDetailsGetWatch(),
  siteNotificationWatch(),
];
